<template>
    <div class="fullHeight">
        <MypageSideMenu @set="initialize" :memberDropClose="true"/>
        <MyPageMemberCode
            ref="membercode"
            v-if="showMemberCode"
            :golfGroupCode="golf_group_code"
            :memberNo="from_set_data.member_no"
            :defaultCode="defaultCode"
            @close-modal="closeModal"
        />
        <div class="mypage_mainwindow">
            <div class="pageTitles">
                <div class="icon-icon-mypage mypage-title-icon"></div>
                マイページトップ
                <button @click="openHelpPage" class="help-btn">ヘルプ</button>
            </div>
            <div
                v-if="showCode"
                class="spview mb-4">
                <button
                    type="button"
                    class="bluebackbutton btn-md btn-block codeBtnWrap"
                    @click="showModal"
                ><div :class="setCodeIcon"></div>スキャンコード表示</button>
            </div>
            <div class="cardwindow mb-3">
                <div class="row mb-3">
                    <div class="col myNumber">
                        <div class="accentBox">
                            <div class="Mypagetop_accentBox__headings">会員番号</div>
                            <div class="accentBox__content">{{ from_set_data.member_no }}</div>
                        </div>
                    </div>
                    <div class="col-4 myLine pcview mr-2">
                        <div class="lineBtn" v-if="line_status">
                            <div class="lineBtn__inner">
                                LINEアカウント連携済
                            </div>
                        </div>
                    </div>
                    <div v-if="member_rank && point_disabled" class="col-7 spview mr-3">
                        <div class="text-right font-weight-bold">保有ポイント: {{ total_points }}P</div>
                    </div>
                </div>
                <div class="row ml-2">
                    <h5 class="col font-weight-bold">{{ from_set_data.full_name }}&nbsp;&nbsp;様</h5>
                </div>
                <div class="row row-notMx mb-3">
                    <div class="col myLine splineview">
                        <div class="lineBtn" v-if="line_status">
                            <div class="lineBtn__inner">
                                LINEアカウント連携済
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-12">
                        <div class="graywindow">
                            <div>
                                <div class="reserveInfoWrap col-12 pb-2" v-if="reserveData">
                                    <div class="sp_not">次回予約：</div>
                                    <div class="font-weight-bold">{{ reserveData.golf_name }}</div>
                                    <div class="playDateWrap">
                                        <div class="sp_label">次回予約：</div>
                                        <div class="font-weight-bold">{{ reserveData.play_date }} {{ reserveData.play_start }}</div>
                                    </div>
                                </div>
                                <div class="reserveNoInfoWrap col-12 pb-2" v-else>
                                    <div class="">次回予約：予約はありません。</div>
                                </div>
                                <div v-if="menuList.length > 0" class="menuWrap col-12">
                                    <button
                                        v-for="(list, index) in menuList" :key="index"
                                        class="bluebackbutton button_item menuBtn w-100 col-12 col-md-5"
                                        @click="gotoPage(list.to)"
                                    >
                                        <div class="menuTitleWrap">
                                            <div :class="list.icon_class" class="mypage-top-icon"></div>
                                            {{ list.title }}
                                        </div>
                                        <div v-if="point_disabled && list.to == '/mypage-point' ">
                                            {{ total_points }}P
                                        </div>
                                        <div class="menuArrowIcon">&or;</div>
                                    </button>
                                    <div
                                        v-if="menuList.length % 2 === 1"
                                        class="col-md-5">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <MypageFooter
            @out-click="logOutBtn"
        />
        <MypageMenuFooter
            @footer-list="getFooterList"/>
    </div>
</template>

<script>
import MypageFooter from './MypageFooter';
import MypageSideMenu from './MypageSideMenu';
import MyPageQrCode from '../components/MyPage/MyPageQrCode';
import MyPageBarCode from '../components/MyPage/MyPageBarCode';
import MyPageMemberCode from '../components/MyPage/MyPageMemberCode';
import { MEMBER_LOG_OUT } from "../../constants/signout";
import { GET_MYPAGE_TOP_INFO } from '../../constants/mypage_top';
import { mapGetters } from 'vuex';
import { memberStatusMixin } from './memberStatusMixin';
import Icon from '../components/Icon';
import { utilityMixin } from '../../mixins/utility';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        MypageFooter,
        MyPageQrCode,
        MyPageBarCode,
        MyPageMemberCode,
        Icon
    },
    mixins: [memberStatusMixin, utilityMixin],
    data () {
        return {
            classBlack: 'text-body',
            classRed: 'text-danger',
            member_rank: false,
            member_no: '',
            use_golf_code: '',
            golf_group_code: process.env.MIX_GROUP_CODE,
            from_set_data: {
                // 会員番号
                member_no: '',
                // フルネーム
                full_name: '',
            },
            line_status: false,
            line_setting_link: {
                title: 'LINEアカウント連携',
                to: '/mypage-line-setting'
            },
            select_point_use: false,
            get_point_use_type: [],
            get_golf_code: '',
            total_points: 0,
            total_normal: 0,
            total_limited: 0,
            total_expected: 0,
            total_reserve: 0,
            // 表示中の期間期限ポイントページネーション数
            display_pagination: 1,
            // 取得した期間期限ポイントデータ格納
            get_limited_point: [],
            // 表示する期間期限ポイントデータ格納
            display_limited_point: [],
            // 期間期限ポイント最大ページネーション数
            max_pagination: 1,
            // 期間限定ポイント一覧のカウント数
            get_limited_point_disp_count: 0,
            display_begin_row: 0,
            display_limit_rows: 3,
            point_flag_normal: 1,
            point_flag_limited_normal: 2,
            point_flag_limited: 3,
            min_valid_date_limited_normal: '',
            min_valid_date_limited: '',
            expected_date: '',
            play_date: '',
            // メッセージ受信の連絡
            message_info: '',
            reserveData: [],
            // ロゴのURL
            imgPath: "/images/" + process.env.MIX_STYLE_NAME + "_logo_2.png",
            // 会員コードの初期表示（true：QR、false：バーコード）
            defaultCode: true,
            showCode: false,
            showMemberCode: false,
            chatOff: false,
            point_disabled: false,
            chat_status: false,
            menuList: [],
            path: ''
        };
    },
    computed: {
        ...mapGetters('auth', [
            "loginMemberLineFlag"
        ]),
        paginationDisabled () {
            return this.max_pagination === 1 || this.max_pagination === 0;
        },
        setCodeIcon () {
            return this.defaultCode ? 'icon-qrcode' : 'icon-barcode';
        },
        setCahtboxCss () {
            return this.chatOff ? 'chatOff' : '';
        }
    },
    async created () {
        await this.initialize();
    },
    watch: {
        display_pagination: function (now) {
            this.display_limited_point = [];
            const nextNum = now * this.display_limit_rows;
            for (var i = nextNum - this.display_limit_rows; i < nextNum; i++) {
                if (this.get_limited_point[i] !== undefined) {
                    this.display_limited_point.push(this.get_limited_point[i])
                }
            }
        },
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        async initialize () {
            this.$store.commit("loading/setIsLoading", true);

            await this.getMypageTop();

            if (this.loginMemberLineFlag) {
                this.line_status = true
                this.line_setting_link.title = 'LINEアカウント連携解除';
                this.line_setting_link.to = '/mypage-line-setting-quit';
            }
            this.from_set_data.member_no = this.$store.state.auth.loginMember.member_no;
            this.from_set_data.full_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
        },
        getMypageTop: async function () {
            try {
                this.$apollo.query({
                    query: GET_MYPAGE_TOP_INFO,
                    variables: {
                        golf_group_code: this.golf_group_code,
                        golf_code: this.$store.state.mypage.useGolfCode,
                        begin_row: this.display_begin_row,
                        limit_rows: this.display_limit_rows
                    }
                }).then(res => {
                    this.showCode = !Boolean(res.data.GetMypageTopInfo.memberCodeSetting);
                    this.defaultCode = res.data.GetMypageTopInfo.displayMemberCodeSetting;
                    this.chatOff = !Boolean(res.data.GetMypageTopInfo.chatboxSetting);
                    this.chat_status = Boolean(res.data.GetMypageTopInfo.chatboxSetting);
                    this.reserveData = res.data.GetMypageTopInfo.ReserveInfo.ReserveList[0];
                    this.member_rank = res.data.GetMypageTopInfo.memberRank;
                    this.time = res.data.GetMypageTopInfo.MessageInfo.time;
                    if (this.time == null || this.time == '' || this.time == undefined) {
                        this.message_info = false;
                    } else {
                        if (res.data.GetMypageTopInfo.MessageInfo.reserve_no === "000000000000") {
                            this.message_info = "返信していないメッセージがあります。(受信日時：" + res.data.GetMypageTopInfo.MessageInfo.time + ")";
                        } else {
                            this.message_info = "返信していないメッセージがあります。(受信日時：" + res.data.GetMypageTopInfo.MessageInfo.time + "　プレー日：" + res.data.GetMypageTopInfo.MessageInfo.play_date + ")";
                        }
                    }

                    if (this.member_rank) {
                        if (res.data.GetMypageTopInfo.pointUseType !== null) {
                            this.select_point_use = true;
                            this.get_point_use_type = res.data.GetMypageTopInfo.pointUseType;
                            if (this.$store.state.mypage.useGolfCode !== null){
                                this.use_golf_code = this.$store.state.mypage.useGolfCode;
                            }else{
                                this.use_golf_code = this.get_point_use_type[0].golf_code;
                            }
                            this.point_disabled = false;
                            this.get_golf_code = this.use_golf_code;
                            this.$store.commit('mypage/useGolfCode', this.get_golf_code);
                        } else {
                            // ポイント利用がゴルフグループ毎の場合、合計ポイント表示
                            this.point_disabled = true;
                            if (!res.data.GetMypageTopInfo.totalPoint.total_all) {
                                this.total_points = 0;
                            } else {
                                this.total_points = res.data.GetMypageTopInfo.totalPoint.total_all;
                            }
                            this.select_point_use = false;
                        }
                    }
                    this.$store.commit("loading/setIsLoading", false);
                })
            } catch(err) {
                this.$store.commit("loading/setIsLoading", false);
                console.log("エラーが起こりました:" + err);
            }
        },
        /* ---------------------------------
         * フッターメニュー取得
         * ------------------------------- */
        getFooterList (list) {
            // 現在のパス取得
            this.path = this.$route.path;

            // マイページトップを除いたメニューリストを取得する
            for (let i = 0; i < list.length; i++) {
                if (list[i].to !== this.path) {
                    this.menuList.push(list[i]);
                }
            }
        },
        logOutBtn () {
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$router.push('/');
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        openHelpPage() {
            window.open('/help', '_blank');
        },
        gotoPage(url) {
            let to = '';
            if (url === '/golf-course-list') {
                to = {name: 'GolfCourseLisst', params: {show: true}};
            } else {
                to = url;
            }
            this.$router.push(to);
        },
        showModal() {
            this.showMemberCode = true;
        },
        closeModal() {
            this.showMemberCode = false;
        }
    }
}

</script>

<style scoped>
/* SP表示時、1ページにつき3つテーブルが表示される仕様なので、
nページ目に変えても常に1、3番目のテーブル背景色がグレーに変わるようにしたい為、
2番目ではないテーブルの色を変更させる */
@media screen and (max-width: 896px) {
    .table-color:not(:nth-of-type(3n-1)){
        background-color: rgba(0, 0, 0, 0.05);
    }
}
.mypageTopWhiteIcon {
    background-color: #ffffff;
    transform: scale(1.2);
    margin-left: 6px;
    margin-right: 8px;
}
.menuWrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    row-gap: 20px;
    column-gap: 20px;
    padding: 30px 20px 30px 20px;
    justify-content: space-around;
    align-items: center;
}
.chatOff {
    visibility: hidden;
}
.menuItemWrap {
    display: flex;
    flex-direction: row;
    align-items: center;
}
.menuTitleWrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    column-gap: 10px;
}
.menuText {
    font-size: 1.2rem;
    font-weight: bold;
}
.reserveInfoWrap {
    height: 3rem;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
    column-gap: 20px;
}
.reserveNoInfoWrap {
    height: 3rem;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: left;
}
.playDateWrap {
    display: flex;
}
.codeBtnWrap {
    display: flex;
    justify-content: center;
    align-items: center;
}
@media screen and (max-width: 896px) {
    .reserveInfoWrap {
        height: 4rem;
        flex-direction: column-reverse;
        align-items: center;
        justify-content: flex-start;
        column-gap: 20px;
    }
    .reserveNoInfoWrap {
        justify-content: center;
    }
    .menuWrap {
        display: none;
    }
}
@media screen and (max-width: 575px) {
    .spview {
        margin-top: 0;
    }
}
</style>
